/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// @flow

// This component renders the Visa floodlights scripts/pixels in a sandboxed iframe

import * as React from 'react';
import { Track } from '@ta/common.tracking';
import { featureIsEnabled } from '@ta/common.features';
import FloodlightTag from '@ta/cpm.iframed-floodlight-tag';
import { getVisaNielsenPixel } from './visa-nielsen-pixels';
import { addTagManagerScript } from './google-tag-manager';
import styles from './sponsorPixels.less';

type Props = {|
  profileName?: string,
  pageName: string,
  contentId: string,
  locale: string,
|};

const COUNTRY_MAPPINGS = {};
COUNTRY_MAPPINGS.uk = 'gb';

/** These are the profiles that are part of Visa's 2019 sponsorship */
export const VisaProfiles: Set<string> = new Set([
  'Visa',
  'VisaDeutschland',
  'VisaFR',
  'VisaPL',
  'VisaRussia',
  'VisaNorge',
]);

class ProfileSponsorshipPixels extends React.Component<Props> {
  static defaultProps = {
    profileName: '',
    contentId: '',
    locale: '',
  };

  componentDidMount() {
    const profileName = this.props.profileName || '';
    if (VisaProfiles.has(profileName) && featureIsEnabled('visa_tag_manager_on_page')) {
      addTagManagerScript('UA-63470806-83');
    }
  }

  // Tracking pixels should only be injected once
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { pageName, contentId, locale } = this.props;
    const profileName = this.props.profileName || '';

    if (VisaProfiles.has(profileName) && featureIsEnabled('visa_profile_sponsorship_tracking')) {
      // floodlight pixels pass country and language in the pixel url
      const localeParts = locale.split('_');
      const country = localeParts[localeParts.length - 1].toLowerCase() || 'na';
      const countryLabel = COUNTRY_MAPPINGS[country] || country;
      const language = localeParts[0] || 'na';

      // We have contracts with multiple Visa "markets" and they each have their own tracking :(
      // These ids are for: na_eu, latam, apac, cemea, PM extra
      const visaFloodlightIds: Array<string> = [
        'DC-5524617',
        'DC-5245590',
        'DC-5219513',
        'DC-5220918',
      ];
      const floodlightTags = visaFloodlightIds.map(id => (
        // Looped elems need a unique key...
        <div className={styles.frameWrapper} key={`VISA_${id}`}>
          <FloodlightTag
            owner={profileName}
            id={id}
            pageName={pageName}
            contentId={contentId}
            country={countryLabel}
            language={language}
            sendTo={`${id.substring(id.indexOf('-') + 1)}/tripa0/tripa0+standard`}
            pxlType="tripa0"
            pxlCat="tripa0"
          />
        </div>
      ));

      // There are Nielsen pixels for a few POS
      const nielsenPixel = getVisaNielsenPixel(profileName, pageName);
      // We don't need Visa|Visa for Profile views
      const trackContext = profileName === contentId ? profileName : `${profileName}|${contentId}`;

      return (
        <React.Fragment>
          <Track
            mount={{
              module: 'visa_social',
              action: pageName,
              context: trackContext,
              once: true,
            }}
          >
            {floodlightTags}
            {nielsenPixel}
          </Track>
        </React.Fragment>
      );
    }
    return null;
  }
}

export default ProfileSponsorshipPixels;
